var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-option',{staticClass:"option",attrs:{"label":_vm.label,"value":_vm.value,"disabled":_vm.disabled}},[_c('el-checkbox',{staticClass:"option-checkbox",attrs:{"value":_vm.isSelected}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }